export let icons: any = {
    "DOCUMENTOS_ICON": "copy",
    "CONEXIONES_ICON": "link",
    "CONFIGURACIONES_ICON": "cog",
    "OPERACIONES_ESP_ICON": "share-alt"
}